'use strict';

import { writable } from 'svelte/store';
import { SINGLE_ROW } from "./ProductLayoutMenu.svelte";

export const mapsLoaded = writable(false);
export const mapsLoading = writable(false);
export const map = writable(null);
export const dirty = writable(false);

export function createDeliverable(deliverable) {
  return writable(deliverable);
}

export function createDeliveryLocation(deliveryLocation) {
  return writable(deliveryLocation);
}

export function createBuilding(building) {
  return writable(building);
}

export function createMoo(moo) {
  return writable(moo);
}

export function createStreet(street) {
  return writable(street);
}

export function createSubdistrict(subdistrict) {
  return writable(subdistrict);
}

export function createDistrict(district) {
  return writable(district);
}

export function createProvince(province) {
  return writable(province);
}

export function createZipcode(zipcode) {
  return writable(zipcode);
}

export function createCountry(country) {
  return writable(country);
}

export function createProductLayout(layout) {
  const productLayout = writable(layout || localStorage.getItem("productLayout") || SINGLE_ROW);
  productLayout.subscribe(layout => localStorage.setItem("productLayout", layout));
  return productLayout;
}